// extracted by mini-css-extract-plugin
module.exports = {"invoiceInput":"VoucherList_invoiceInput__2fUYP","organizationSelect":"VoucherList_organizationSelect__189SJ","table":"VoucherList_table__1fNoC","form":"VoucherList_form__EZT3O"};